import React from 'react';
import { FlexColumn } from 'ui-components/components/flex';

import style from './recommendations.module.less';
import { SaveShippingDefaultRecommendation } from './save-shipping-default-recommendation/save-shipping-default-recommendation';

const Recommendations = () => {
  return (
    <FlexColumn className={style.wrapper}>
      <SaveShippingDefaultRecommendation className={style['recommendation-field']} />
    </FlexColumn>
  );
};

export default Recommendations;
